import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import * as _ from "underscore";
import { UserData } from "../shared/service/UserService";
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@Injectable()
export class ContentManagementService {
  uniqueIdentifier = "";
  private apiUrl: string;
  private header;
  private headerAppJSON;
  constructor(private http: HttpClient, private route: ActivatedRoute) {
    this.uniqueIdentifier = this.route.snapshot.queryParamMap.get("identifier");
    this.apiUrl = UserData.backend_url + "/v1";
    this.header = this.getHeader();
    this.headerAppJSON = this.getHeaderAppJSON();
  }

  public getHeader() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
      }),
    };
    return httpOptions;
  }

  public getHeaderAppJSON() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: authorizationString,
        "Content-Type": "application/json",
      }),
    };
    return httpOptions;
  }

  public createGroup(data) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/createPraticeSetGroup";
    return this.http.post(url, data, this.header);
  }

  public subApps() {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/getIDsForApps";
    //const url = this.apiUrl + '/getIDsForApps';
    return this.http.get(url, this.header);
  }

  public getGroup(baseId) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/getAllPracticeGroups/" + baseId;
    return this.http.get(url, this.header);
  }

  public deleteGroup(obj) {
    let organizationId: any = "noOrg";
    let url = "";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    if (obj.practiceGroupBaseId == null) url = this.apiUrl + "/practiceSets/" + obj.practiceGroupBaseId + "/" + obj.practicSetId;
    else url = this.apiUrl + "/organizations/" + organizationId + "/deletePracticeGroupByID/" + obj.practiceGroupBaseId + "/" + obj.appBaseId;
    return this.http.delete(url, this.header);
  }

  public deletePracticeSet(obj) {
    const url = this.apiUrl + "/practiceSets/" + obj.practiceGroupId + "/" + obj.practicSetId;
    return this.http.delete(url, this.header);
  }

  public getPracticeSetData(PracticeGroupId, practiceSetId) {
    const url = this.apiUrl + "/practiceGrps/" + PracticeGroupId + "/practiceSets?practiceSetId=" + practiceSetId;
    return this.http.get(url, this.header);
  }

  public getDetailViewData(PracticeGroupId, practiceSetId, appName) {
    const url = this.apiUrl + "/practiceSetTablesDetailedView/" + PracticeGroupId + "/" + practiceSetId + "?appName=" + appName;
    return this.http.get(url, this.header);
  }

  public getGameData(PracticeGroupId, practiceSetId) {
    const url = this.apiUrl + "/practiceSetTablesDetailedViewForURL/" + PracticeGroupId + "/" + practiceSetId;
    return this.http.get(url, this.header);
  }
  public getGameShareData(PracticeGroupId, practiceSetId) {
    const url = this.apiUrl + "/guestInvitation/practiceSetTablesDetailedViewForURL/" + PracticeGroupId + "/" + practiceSetId;
    return this.http.get(url);
  }

  public createPracticeSet(data, PracticeGroupId, appName, singleOrgApp) {
    let url: string = "";
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    if (singleOrgApp)
      // Single
      url = this.apiUrl + "/practieGrpBases/" + PracticeGroupId + "/praticeSet?appName=" + appName;
    // Multiple
    else url = this.apiUrl + "/organizations/" + organizationId + "/practieGrpBases/" + PracticeGroupId + "/praticeSet?appName=" + appName;
    return this.http.post(url, data, this.header);
  }

  public getTableData(obj) {
    const url = this.apiUrl + "/practiceSetTables/" + obj.practiceGroupId + "/" + obj.practeceSetId;
    return this.http.get(url, this.header);
  }

  public editGroupName(obj) {
    const url = this.apiUrl + "/editPracticeGroup/" + obj.baseAppId + "/" + obj.practiceGroupBaseId + "?isPrivate=" + obj.isPrivate;
    return this.http.post(url, { name: obj.practiceGroupName }, { headers: this.header });
  }

  public assignParentFolder(obj) {
    const url = this.apiUrl + "/assignParentFolder/" + obj.baseAppId + "/" + obj.id + "/" + obj.parentId;
    return this.http.post(url, this.header);
  }

  public editPracticeSetSingleName(obj) {
    const url = this.apiUrl + "/practiceSets/" + obj.practiceGroupBaseId + "/" + obj.setID + "/" + obj.practiceSetName + "?isPrivate=" + obj.isPrivate;
    return this.http.post(url, this.header);
  }

  public editPracticeSetName(obj) {
    const url = this.apiUrl + "/practiceSets/" + obj.groupId + "/" + obj.practiceSetId + "/" + obj.practiceSetName;
    return this.http.post(url, this.header);
  }

  public groupPrecticeSetDownload(obj): Observable<Blob> {
    const url = this.apiUrl + "/exportInZipCSV/" + obj.appId + "/" + obj.practiceGroupBaseId + "/practiceSets";
    return this.http.get(url, {
      responseType: "blob",
    });
  }

  public getVersionData(tableId, versionId) {
    const url = this.apiUrl + "/uicm/tables/" + tableId + "/versions/" + versionId;
    return this.http.get(url, this.header);
  }

  public saveCellData(data, selectedTableId, currentVersionId) {
    const url = this.apiUrl + "/saveReferenceMaterialRowCM?tableId=" + selectedTableId + "&&versionId=" + currentVersionId;
    return this.http.post(url, data, this.headerAppJSON);
  }

  public deleteMaterial(selectedTableId, data, currentVersionId) {
    const url = this.apiUrl + "/deleteReferenceMaterialRowCM?tableId=" + selectedTableId + "&&versionId=" + currentVersionId;
    return this.http.post(url, data, this.headerAppJSON);
  }

  public getFolder(gameId) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/folders";
    return this.http.get(url, this.header);
  }

  public createFolderAndPracticeSet(gameId, data) {
    let organizationId: any = "noOrg";
    let url: any = "";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesets";
    return this.http.post(url, data, this.header);
  }

  public getFolderAndPracticeSet(gameId, selectFolder) {
    let organizationId: any = "noOrg";
    let url: any = "";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    if (selectFolder.id == 1) url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesetsUI?folder=null";
    else url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesetsUI?folder=" + selectFolder.id;
    return this.http.get(url, this.header);
  }

  public getFPDetailView(gameId) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesetsUI";
    return this.http.get(url, this.header);
  }

  public setPracticeSetColor(color, groupId, practeceSetId) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/" + groupId + "/practicesets/" + practeceSetId + "?color=" + color;
    return this.http.post(url, this.header);
  }

  public createFolder(gameId, data) {
    let organizationId: any = "noOrg";
    let url: any = "";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/folders";
    return this.http.post(url, data, this.header);
  }

  public editPracticeSetNameColor(obj, data) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    let url =
      this.apiUrl +
      "/" +
      obj.practiceGroupId +
      "/practicesets/" +
      obj.practicesetId +
      "?color=" +
      obj.color +
      "&folderId=" +
      obj.folderId +
      "&organizationId=" +
      organizationId +
      "&isPrivate=" +
      obj.isPrivate;
    return this.http.post(url, data, this.header);
  }

  public saveImage(data) {
    const url = this.apiUrl + "/saveImage";
    return this.http.post(url, data, this.header);
  }

  public setRecords(leaderboardID, data) {
    let url = this.apiUrl + "/tables/" + leaderboardID + "/records";
    return this.http.post(url, data, this.header);
  }

  public setRecordsAsync(leaderboardID, data) {
    let url = this.apiUrl + "/tables/" + leaderboardID + "/records";
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UserData.token,
        organizationId: UserData.organizationId,
        gameId: localStorage.getItem("gameId"),
      },
      body: data,
      keepalive: true,
    });
  }

  public getRecords(leaderboardID) {
    let url = this.apiUrl + "/tables/" + leaderboardID;
    return this.http.get(url, this.header);
  }

  public getTopFolders(id) {
    const url = this.apiUrl + "/organizations/" + id;
    return this.http.get(url, this.header);
  }

  public exportGameData(data) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    data.organizationId = organizationId;
    let url = this.apiUrl + "/createMatchSetFromWordSet";
    return this.http.post(url, data, this.header);
  }

  public sessionCreate(data, gameId, practicesetId) {
    let organizationId: any = "noOrg";
    let sessionsId = localStorage.getItem("sessionsId");
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesets/" + practicesetId + "/sessionsUI" + (sessionsId !== null ? "?sessionsId=" + sessionsId : "");
    return this.http.post(url, data, this.header);
  }

  public sessionUpdate(data, practicesetId, sessionsId) {
    const url = this.apiUrl + "/practicesets/" + practicesetId + "/sessions/" + sessionsId;
    return this.http.put(url, data, this.header);
  }

  public getContinuePractSet(gameId, practicesetId, lastCreated, gameSubType) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null || organizationId == "" ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId + "/practicesets/" + practicesetId + "/sessions/" + "?lastCreated=" + lastCreated + "&gameSubType=" + gameSubType;
    return this.http.get(url, this.header);
  }

  public deleteGame(gameId) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/games/" + gameId;
    return this.http.delete(url, this.header);
  }

  public duplicate(data, practiceGropBaseId, practiceSetId, appName) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/practieGrpBases/" + practiceGropBaseId + "/praticeSet/" + practiceSetId + "?appName=" + appName;
    return this.http.post(url, data, this.header);
  }

  public sessionDataList(practiceSetId) {
    let url = this.apiUrl + "/livesessions/" + practiceSetId + "/alllivesessions";
    return this.http.get(url, this.header);
  }

  public getgameLevelPermissions() {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/userGamePermissionsMapping";
    return this.http.get(url, this.header);
  }

  public updateSetPrivateFolder(obj, flag) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/folders/" + obj.practiceGroupBaseId + "/setFolderPrivate" + "?isPrivate=" + flag;
    return this.http.post(url, this.header);
  }

  public updateSetPrivatePrSet(obj, flag) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/organizations/" + organizationId + "/practicesets/" + obj.practiceSetId + "/setPrSetPrivate" + "?isPrivate=" + flag;
    return this.http.post(url, this.header);
  }

  // GAMES ANALYTICS

  public getGamesAnalyticsLiveSessionUsage(pSetId) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/liveSessionUsage";
    return this.http.get(url, this.header);
  }

  public getGamesAnalyticsLiveSessionTrends(pSetId) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetAnalyticsUsage";
    return this.http.get(url, this.header);
  }

  public questionsChart(pId) {
    let organizationId: any = "noOrg";
    if (!_.isUndefined(UserData.organizationId)) organizationId = UserData.organizationId;
    organizationId = organizationId == null ? "noOrg" : organizationId;
    const url = this.apiUrl + "/analytics/practicesets/" + pId + "/pratSetQuesRecordAnalyticsUsage";
    return this.http.get(url, this.header);
  }

  public userDetailsChart(pSetId) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsage";
    return this.http.get(url, this.header);
  }

  public userDetailsChartByDateRange(pSetId, fromDate, toDate) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsageRange?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getLastPSetActiveUsers(fromDate, toDate, flag, pSetId) {
    let url: any = "";
    if (flag) url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsageDetails";
    else url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsageRange?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public recentUserData(pSetId, data) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsage?day=" + data;
    else if (data == "month") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsage?month=" + data;
    else if (data == "year") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsage?year=" + data;
    return this.http.get(url, this.header);
  }
  public listQuestionsData(pSetId, data) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/pratSetQuesRecordAnalyticsUsage?day=" + data;
    else if (data == "month") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/pratSetQuesRecordAnalyticsUsage?month=" + data;
    else if (data == "year") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/pratSetQuesRecordAnalyticsUsage?year=" + data;
    return this.http.get(url, this.header);
  }

  public listQuestionsRangeData(pSetId, fromDate, toDate) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/pratSetQuesRecordAnalyticsUsage?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getGamesAnalyticsUsage(pSetId, data) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetAnalyticsUsage?usageType=" + data;
    else if (data == "month") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetAnalyticsUsage?usageType=" + data;
    else if (data == "year") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetAnalyticsUsage?usageType=" + data;
    return this.http.get(url, this.header);
  }

  public getGamesAnalyticsUsageRangeData(pSetId, fromDate, toDate) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetAnalyticsUsage?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getGamesLiveSession(pSetId, data) {
    let url: any = "";
    if (data == "day") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/liveSessionUsage?day=" + data;
    else if (data == "month") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/liveSessionUsage?month=" + data;
    else if (data == "year") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/liveSessionUsage?year=" + data;
    return this.http.get(url, this.header);
  }

  public getGamesLiveSessionRangeDate(pSetId, fromDate, toDate) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/liveSessionUsage?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getActiveUsersData(pSetId, type) {
    let url: any = "";
    if (type == "day") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsageDetails?day=" + type;
    else if (type == "month") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsageDetails?month=" + type;
    else if (type == "year") url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsageDetails?year=" + type;
    return this.http.get(url, this.header);
  }

  public getActiveUsersDateRange(pSetId, fromDate, toDate) {
    const url = this.apiUrl + "/analytics/practicesets/" + pSetId + "/practiceSetActiveUsersUsageRange?fromDate=" + fromDate + "&toDate=" + toDate;
    return this.http.get(url, this.header);
  }

  public getCsvData(analyticType: any, selectedDateType: any, pSetId: any, startDate: any, endDate: any): Observable<Blob> {
    let url: any = "";
    if (analyticType) {
      if (selectedDateType == "day" || selectedDateType == "month" || selectedDateType == "year") {
        url = this.apiUrl + "/practiceSetAnalytics/" + pSetId + "/recordUsage?analyticsType=" + analyticType + "&usageType=" + selectedDateType;
      } else {
        url = this.apiUrl + "/practiceSetAnalytics/" + pSetId + "/recordUsage?analyticsType=" + analyticType + "&fromDate=" + startDate + "&toDate=" + endDate;
      }
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public sessionUpdateAsync(data, practicesetId, sessionsId) {
    const url = this.apiUrl + "/practicesets/" + practicesetId + "/sessions/" + sessionsId + `?gameStatus=Done`;
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + UserData.token,
        organizationId: UserData.organizationId,
        gameId: new Map<string, string>(JSON.parse(localStorage.getItem("practiceSetIdMap"))).get(this.uniqueIdentifier),
      },
      body: data,
      keepalive: true,
    });
  }
}
